"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerSharingContract = void 0;
const contract_1 = require("../base/contract");
const sharing_schemas_1 = require("../../schemas/customer/sharing.schemas");
const api_schemas_1 = require("../../schemas/base/api.schemas");
/**
 * Customer Sharing Contract
 *
 * PRD Note: Sharing is via WhatsApp (FR37-44).
 * POST /sharing creates the share record AND triggers the WhatsApp message asynchronously.
 */
exports.CustomerSharingContract = (0, contract_1.createContract)({
    name: 'CustomerSharing',
    baseUrl: '/sharing',
    version: '1',
    serviceModule: 'user',
    endpoints: {
        createShare: {
            method: 'POST',
            path: '/',
            body: sharing_schemas_1.createShareBodySchema,
            query: null,
            params: null,
            headers: null,
            response: {
                success: sharing_schemas_1.createShareResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    notFound: api_schemas_1.baseErrorResponseSchema, // Coupon not found or not owned
                    badRequest: api_schemas_1.baseErrorResponseSchema, // Coupon already shared, expired, or used
                },
            },
            middleware: ['auth:required'],
            documentation: {
                summary: 'Create a share',
                description: 'Creates a share for a coupon and triggers WhatsApp message to recipient. Coupon must be active and owned by the user.',
                tags: ['Customer', 'Sharing'],
                deprecated: false,
            },
            tests: [
                'should create share and return share code',
                'should trigger WhatsApp message asynchronously',
                'should return 404 for non-existent coupon',
                'should return 400 for already shared coupon',
                'should return 400 for expired coupon',
            ],
        },
        getShareAnalytics: {
            method: 'GET',
            path: '/analytics/:userCouponId',
            body: null,
            query: null,
            params: sharing_schemas_1.getShareAnalyticsParamsSchema,
            headers: null,
            response: {
                success: sharing_schemas_1.getShareAnalyticsResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    notFound: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ['auth:required'],
            documentation: {
                summary: 'Get share analytics for a coupon',
                description: 'Returns share count, view count, and share history for a user coupon',
                tags: ['Customer', 'Sharing'],
                deprecated: false,
            },
            tests: [
                'should return analytics for shared coupon',
                'should return empty shares array for unshared coupon',
                'should return 404 for coupon not owned by user',
            ],
        },
    },
});
